import { useState, useEffect } from 'react';
import axios from 'axios';

const useUsers = () => {
  const [users, setUsers] = useState([]); // Initial state as an empty array
  const [loading, setLoading] = useState(true); // Track loading state
  const [error, setError] = useState(null); // Track error state

  // Function to fetch users
  const fetchUsers = async () => {
    setLoading(true);
    setError(null); // Reset error state on new request
    try {
      const response = await axios.get('https://ipms.insollex.com/api/users');
      console.log('Fetched users:', response.data); // Debugging the response

      if (Array.isArray(response.data)) {
        setUsers(response.data); // Correctly set the users data
      } else {
        console.error('Expected an array but received:', response.data);
        setUsers([]); // Set to empty array if not an array
      }
    } catch (error) {
      console.error('Error fetching users:', error);
      // You can display more specific error details if needed.
      if (error.response) {
        setError(`Error: ${error.response.status} - ${error.response.data.message}`);
      } else if (error.request) {
        setError('Network Error. Please check your connection.');
      } else {
        setError(`Unexpected Error: ${error.message}`);
      }
    } finally {
      setLoading(false);
    }
  };

  // Fetch users when component mounts or when refetch is triggered
  useEffect(() => {
    fetchUsers();
  }, []); // Empty dependency array means this runs only once, on mount

  return { users, loading, error, refetch: fetchUsers }; // Return the users, loading, error state, and refetch function
};

export default useUsers;
